import { FormBase } from 'core/components';

export default class NikoInsuranceManagementEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'NIKO_INSURANCE_MANAGEMENT.EDIT.NAME_LABEL',
                    placeholder: 'NIKO_INSURANCE_MANAGEMENT.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'required'],
                },
                {
                    name: 'abbreviatedName',
                    label: 'NIKO_INSURANCE_MANAGEMENT.EDIT.ABBREVIATED_NAME_LABEL',
                    placeholder: 'NIKO_INSURANCE_MANAGEMENT.EDIT.ABBREVIATED_NAME_PLACEHOLDER',
                    rules: ['string'],
                },
                {
                    name: 'description',
                    label: 'NIKO_INSURANCE_MANAGEMENT.EDIT.DESCRIPTION_LABEL',
                    placeholder: 'NIKO_INSURANCE_MANAGEMENT.EDIT.DESCRIPTION_PLACEHOLDER',
                    type: 'textarea',                    
                    rules: 'string'
                },
                {
                    name: 'primarySort',
                    label: 'NIKO_INSURANCE_ORDERING.CREATE.PRIMARY_SORT_LABEL',
                    type: 'integer',
                },
                {
                    name: 'secondarySort',
                    label: 'NIKO_INSURANCE_ORDERING.CREATE.SECONDARY_SORT_LABEL',
                    type: 'integer'
                },
                {
                    name: "pricingGroupId",
                    label: "Pricing Group",
                    placeholder: "Select Pricing Group",
                    rules: 'required'
                },
                {
                    name: "placeOfServiceId",
                    label: "POS",
                    placeholder: "Select a POS",
                    rules: 'required'
                },
                {
                    name: "branchOfficeId",
                    label: "Branch Office",
                    placeholder: "Select a Branch Office",
                    rules: 'required'
                },
                {
                    name: "drainageBagAllowable",
                    label: "Drainage Bag Allowable",
                    placeholder: "Select Drainage Bag Allowable",
                    value: 2,
                    rules: 'required'
                },
                {
                    name: 'isDateSpanHold',
                    label: 'NIKO_INSURANCE_MANAGEMENT.EDIT.DATE_SPAN_HOLD_LABEL',
                    type: 'checkbox',
                },
            ],
        };
    }
}
